var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content__block ql-editor",domProps:{"innerHTML":_vm._s(_vm.program.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }